window.addEventListener('beep-play', async () => {
    const { default: alarm } = await import('./beep')
    alarm();
});

window.addEventListener('alarm-play', async () => {
    const { default: alarm } = await import('./alarm')
    alarm();
});

window.addEventListener('new-play', async () => {
    const { default: alarm } = await import('./new_message')
    alarm();
});
